import { BeatLoader } from "react-spinners";

const SmallLoader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "30vh",
      }}
    >
      <BeatLoader color="#3661eb" />
    </div>
  );
};

export default SmallLoader;
